import { UserRoleCategory } from './UserRoleCategory';

export const UserRoleCategoryPath: { [key in UserRoleCategory]: string } = {
  [UserRoleCategory.Admin]: '/admin',
  [UserRoleCategory.Agent]: '/agent',
  [UserRoleCategory.CorporateUser]: '/corporate-user',
  [UserRoleCategory.Customer]: '',
};
